// Defining the area libary or timeline
import {heroSearch} from "src/components/hero/hero";
import searchpostrender from "src/components/search/search_postrender";

import { articlesExtend, getDynamicContent, findsite } from "src/scripts/mixin";


export default () => {

    const contentcontainer = document.getElementById("site_content");

    let r = ``;

    const siteinfo = findsite();
    
    document.title = siteinfo.previewItem + " - Kongsberg historiefortelling";
    
    // let html ``;
    
    r += `<div id="herosearch"></div>`;
    
    heroSearch( () => {
        searchpostrender();
    });
    

    // r = hero(data);
    contentcontainer.innerHTML = r;//JSON.stringify(siteinfo);


}
